var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberHelpRoundHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5, .cls-7 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-7 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 1.34px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.27px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-6 {\r\n        font-size: 8.82px;\r\n      }\r\n\r\n      .cls-6, .cls-8 {\r\n        font-family: ArialMT, Arial;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-8 {\r\n        font-size: 8.82px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MemberHelpRoundHollw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberRoundHollow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.38,125.33l-3.27-.22-3.22-.64-3.1-1-3.2-1.62-2.47-1.65L105.65,118l-2.16-2.47-1.82-2.72-1.45-3-1-3.1-.64-3.19-.2-3.56.2-3,.64-3.18,1-3.11,1.62-3.2L103.49,85l2.16-2.47,2.47-2.16,2.72-1.82,3-1.45,3.1-1.06,3.22-.64,3.27-.21,3.27.21,3.21.64L133,77.11l3.2,1.62,2.46,1.65,2.47,2.16L143.26,85l1.83,2.72,1.44,2.94,1.06,3.11.63,3.18.22,3.3-.22,3.3-.63,3.19-1.06,3.1-1.44,3-1.83,2.72L141.1,118l-2.47,2.16L135.91,122,133,123.42l-3.11,1-3.21.64Zm0,8.35,4.36-.29,4.29-.84,4.14-1.41,3.92-1.93,3.63-2.44L147,123.9l2.88-3.29,2.43-3.64,2-4.17,1.32-3.89.84-4.25.28-4.66-.28-4.14-.84-4.25-1.41-4.14-1.93-3.92-2.43-3.63L147,76.63l-3.29-2.88-3.63-2.43-3.92-1.93L132,68l-4.29-.85-4.36-.29-4.36.29-4.29.85-4.14,1.41-3.92,1.93L103,73.75l-3.28,2.88-2.88,3.29-2.44,3.63L92.5,87.47l-1.4,4.14-.85,4.25-.29,4.4.29,4.4.85,4.25,1.4,4.14L94.43,117l2.44,3.64,2.88,3.29,3.28,2.87,3.64,2.44,4.17,2,3.89,1.33,4.29.84Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "89.96 100.26 90.25 104.66 91.09 108.91 92.5 113.05 94.43 116.97 96.87 120.61 99.75 123.89 103.03 126.78 106.67 129.21 110.59 131.14 114.73 132.54 119.02 133.4 123.38 133.68 127.74 133.4 132.03 132.54 136.17 131.14 140.09 129.21 143.72 126.78 147.01 123.89 149.89 120.61 152.32 116.97 154.25 113.05 155.66 108.91 156.5 104.66 156.8 100.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "156.8 100.26 156.5 95.86 155.66 91.61 154.25 87.47 152.32 83.55 149.89 79.92 147.01 76.63 143.72 73.75 140.09 71.32 136.17 69.39 132.03 67.98 127.74 67.13 123.38 66.84 119.02 67.13 114.73 67.98 110.59 69.39 106.67 71.32 103.03 73.75 99.75 76.63 96.87 79.92 94.43 83.55 92.5 87.47 91.09 91.61 90.25 95.86 89.96 100.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "98.31 100.26 98.53 96.96 99.17 93.78 100.22 90.67 101.67 87.73 103.49 85.01 105.65 82.54 108.12 80.38 110.84 78.56 113.79 77.11 116.89 76.05 120.11 75.42 123.38 75.2 126.65 75.42 129.87 76.05 132.97 77.11 135.91 78.56 138.63 80.38 141.1 82.54 143.26 85.01 145.09 87.73 146.53 90.67 147.59 93.78 148.22 96.96 148.44 100.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "148.44 100.26 148.22 103.56 147.59 106.75 146.53 109.85 145.09 112.8 143.26 115.52 141.1 117.99 138.63 120.15 135.91 121.97 132.97 123.42 129.87 124.47 126.65 125.11 123.38 125.33 120.11 125.11 116.89 124.47 113.79 123.42 110.84 121.97 108.12 120.15 105.65 117.99 103.49 115.52 101.67 112.8 100.22 109.85 99.17 106.75 98.53 103.56 98.31 100.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 148.44,
    y1: 100.26,
    x2: 148.44,
    y2: 101.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 156.8,
    y1: 100.26,
    x2: 156.8,
    y2: 101.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 123.38,
    y1: 100.26,
    x2: 155.77,
    y2: 108.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "93.08 86.15 90.98 92.05 90.02 98.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "153.67 114.37 155.77 108.48 156.74 102.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.98 92.05 98.81 95.17 99.35 93.04 90.98 92.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "90.98 92.05 98.81 95.17 99.35 93.04 90.98 92.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.77 108.48 147.94 105.36 147.4 107.49 155.77 108.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "155.77 108.48 147.94 105.36 147.4 107.49 155.77 108.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 123.38,
    y1: 100.26,
    x2: 90.98,
    y2: 92.05
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(107.39 91.27) rotate(14.23)"
  }, "Diameter"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 144.27,
    y1: 65.42,
    x2: 160.98,
    y2: 65.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "152.62 65.42 153 62.62 154.09 60.1 155.79 58.1 157.94 56.81 160.32 56.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 156.8,
    y1: 65.42,
    x2: 154.71,
    y2: 67.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 156.8,
    y1: 65.42,
    x2: 158.89,
    y2: 63.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 156.8,
    y1: 65.42,
    x2: 156.8,
    y2: 61.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 156.8,
    y1: 65.42,
    x2: 156.8,
    y2: 87.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 148.44,
    y1: 65.42,
    x2: 146.35,
    y2: 67.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 148.44,
    y1: 65.42,
    x2: 150.53,
    y2: 63.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 148.44,
    y1: 65.42,
    x2: 148.44,
    y2: 61.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 148.44,
    y1: 65.42,
    x2: 148.44,
    y2: 90.37
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(160.32 59.63)"
  }, "Thickness"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberHelpRoundHollow);
export default __webpack_public_path__ + "static/media/MemberHelpRoundHollow.9dc247fb37ae555e04be638f3507c515.svg";
export { ForwardRef as ReactComponent };